import axios from "axios";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "bn_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const login = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
export const getSeason = (date) => api.get("/season", { params: { date } }).then((r) => r.data);

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createConsultation = (payload) =>
  api.post("/consultations", payload).then((r) => r.data);
export const getLeads = () => api.get("/leads").then((r) => r.data);
export const getConsultations = () => api.get("/consultations").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
